export default __webpack_public_path__ + "static/media/lab-tape.6f541fd6.svg";